import type { OnEmbeddedContentAction } from '@atlassian/embedded-confluence';
import type { UIAnalyticsEvent } from '@atlassian/jira-product-analytics-bridge';
import { useConfluenceDummyLinkContext } from '../confluence-dummy-link-context/index.tsx';
import { useDraftEmbeddedPageModalEntryPoint } from './index.tsx';

interface UseDraftEpModalProps {
	onEmbeddedContentAction?: OnEmbeddedContentAction;
	onPublish?: () => void;
	linkConfluencePage?: (link: string, analyticsEvent: UIAnalyticsEvent) => void;
}

export const useDraftEpModal = ({
	onEmbeddedContentAction,
	onPublish,
	linkConfluencePage,
}: UseDraftEpModalProps) => {
	const { isEpModalOpen, activePageUrl, setIsEpModalOpen, setIsLoading } =
		useConfluenceDummyLinkContext();

	const { epModalEntryPointContainer } = useDraftEmbeddedPageModalEntryPoint({
		isEpModalOpen,
		setIsEpModalOpen,
		activePageUrl,
		embeddedConfluenceSource: 'jswIssueView',
		onEmbeddedContentAction,
		onPublish,
		setIsLoading,
		linkConfluencePage,
	});

	return epModalEntryPointContainer;
};
